/**
 * An HTTP error when communicating with the backend API.
 */
export class HttpError extends Error {
  /**
   * @param response The underlying transport error or response (opaque — kept
   * for diagnostics only; consumers branch on `reportable`, not on this).
   * @param reportable True if this error should be reported to Bugsnag, false
   * if this error doesn't represent something we can fix on the frontend.
   */
  constructor(response: unknown, reportable = true) {
    super('An HTTP error occurred when making the request.');
    this.reportable = reportable;
    this.response = response;
  }

  reportable: boolean;
  response: unknown;
}

/**
 * Problem details.
 */
export type Problem = {
  type: string;
  title: string;
  status: number;
  detail: string;
  traceId: string;
}

/**
 * A validation error from the server.
 */
export class ValidationError extends Error {
  constructor(messages: string | string[], title: string) {
    const messageArray = Array.isArray(messages) ? messages : [messages];
    super(messageArray.join('\n'));
    this.title = title;
    this.messages = messageArray;

    Object.setPrototypeOf(this, ValidationError.prototype);
  }

  title: string;
  messages: string[];
}
